import React, { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import Icon, {
  AudioOutlined,
  AudioMutedOutlined,
  PushpinOutlined,
  DesktopOutlined,
  LikeOutlined,
  CloseSquareOutlined
} from "@ant-design/icons";

// import Icon from "@ant-design/icons";

import { ReactComponent as CameraDisable } from "@/assets/camera-disable.svg";
import { ReactComponent as Camera } from "@/assets/camera.svg";

import { ReactComponent as SoundDisable } from "@/assets/soundmute.svg";
import { ReactComponent as Sound } from "@/assets/sound.svg";
import { ReactComponent as StartCall } from "@/assets/startcall.svg";
import { ReactComponent as EndCall } from "@/assets/endcall.svg";

import { ReactComponent as Pin } from "@/assets/pin.svg";
import { ReactComponent as PinSlash } from "@/assets/pin-slash.svg";

interface PropType {
  active: boolean;
}

export const AudioIcon = ({ active }: PropType) => {
  return active ? (
    <AudioOutlined />
  ) : (
    <AudioMutedOutlined className="color-danger" />
  );
};

export interface MicrophoneIconRef {
  drawVolume: (value: number) => void
}

interface MediaIconProps extends PropType {
  // ref?: RefObject<MicrophoneIconRef | null>
}

export const MediaIcon = forwardRef<MicrophoneIconRef, MediaIconProps>(({ active }: MediaIconProps, ref) => {
  const size = 16;

  const max = 512

  const volumeRef = useRef<SVGRectElement & { style: { height: string; y: string } } | null>(null)

  const drawVolume = useCallback((value: number) => {
    const newHeight = value / 100 * max
    const newY = 640 - newHeight

    if (volumeRef.current) {
      volumeRef.current.style.height = `${newHeight}`
      volumeRef.current.style.y = `${newY}`
      requestAnimationFrame(() => drawVolume(value))
    }

  }, [volumeRef])

  useImperativeHandle(ref, () => ({
    drawVolume,
  }))
  
  return active ? (
    <svg
      className="mic-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      color="#000"
    >
      <rect
        className="speaking-animation"
        x="384"
        ref={volumeRef}
        width="256"
        fill="#26d726"
      >
      </rect>
      <path fill="currentColor" d="M512 128a128 128 0 0 0-128 128v256a128 128 0 1 0 256 0V256a128 128 0 0 0-128-128m0-64a192 192 0 0 1 192 192v256a192 192 0 1 1-384 0V256A192 192 0 0 1 512 64m-32 832v-64a288 288 0 0 1-288-288v-32a32 32 0 0 1 64 0v32a224 224 0 0 0 224 224h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64z" />
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 1024 1024" color="rgb(255, 77, 79)">
      <path fill="currentColor" d="m412.16 592.128l-45.44 45.44A191.23 191.23 0 0 1 320 512V256a192 192 0 1 1 384 0v44.352l-64 64V256a128 128 0 1 0-256 0v256c0 30.336 10.56 58.24 28.16 80.128m51.968 38.592A128 128 0 0 0 640 512v-57.152l64-64V512a192 192 0 0 1-287.68 166.528zM314.88 779.968l46.144-46.08A223 223 0 0 0 480 768h64a224 224 0 0 0 224-224v-32a32 32 0 1 1 64 0v32a288 288 0 0 1-288 288v64h64a32 32 0 1 1 0 64H416a32 32 0 1 1 0-64h64v-64c-61.44 0-118.4-19.2-165.12-52.032M266.752 737.6A286.98 286.98 0 0 1 192 544v-32a32 32 0 0 1 64 0v32c0 56.832 21.184 108.8 56.064 148.288z" />
      <path fill="currentColor" d="M150.72 859.072a32 32 0 0 1-45.44-45.056l704-708.544a32 32 0 0 1 45.44 45.056z" />
    </svg>
  );
});

export const CloseSquareIcon = ({ active }: PropType) => {
  return active ? (
    <CloseSquareOutlined />
  ) : (
    <CloseSquareOutlined className="color-danger" />
  );
};

export const VideoIcon = ({ active }: PropType) => {
  return active ? (
    <Icon component={Camera} width={16} height={16} />
  ) : (
    <Icon
      component={CameraDisable}
      className="color-danger"
      width={16}
      height={16}
    />
  );
};

export const SoundIcon = ({ active }: PropType) => {
  return active ? (
    <Icon component={Sound} width={16} height={16} />
  ) : (
    <Icon
      component={SoundDisable}
      className="color-danger"
      width={16}
      height={16}
    />
  );
};

export const ShareIcon = ({ active }: PropType) => {
  return active ? (
    <DesktopOutlined />
  ) : (
    <DesktopOutlined className="color-danger" />
  );
};

export const HandIcon = ({ active }: PropType) => {
  return active ? <LikeOutlined /> : <LikeOutlined className="color-danger" />;
};

export const PinIcon = ({ active }: PropType) => {
  return active ? (
    <Icon component={PinSlash} width={32} height={32} style={{ color: "#40a9ff" }} title="取消钉选" />
  ) : (
    <Icon component={Pin} width={32} height={32} title="钉选" />
  );
};

export const TerminalCallIcon = ({ active }: PropType) => {
  //return active ? <StartCall /> : <EndCall />;

  return active ? (
    <Icon component={StartCall} width={32} height={32} />
  ) : (
    <Icon
      component={EndCall}
      className="color-danger"
      width={32}
      height={32}
    />
  );
}
